import { z } from 'zod'

const CUSTOM_FIELD_MAX_LENGTH = 30

export const createCFFields = {
  names: {
    fieldProps: {
      autoFocus: true,
      label: 'Custom Fields',
      name: 'names',
      helperText:
        'Press Enter or a comma to save each choice. You can also paste in a list of custom fields with each one on a separate line or separated by commas. Then press Enter.',
    },
    type: 'tags',
  },
} as const

const nameSchema = z
  .string({
    required_error: 'Custom field name cannot be empty',
  })
  .min(1)
  .max(CUSTOM_FIELD_MAX_LENGTH, 'Custom field name cannot exceed 30 characters')

export const createCFSchema = z.object({
  names: z
    .array(nameSchema)
    .min(1, 'Please enter at least one custom field')
    .refine((names) => {
      const lowercaseNames = names.map((name) => name.toLowerCase())
      return new Set(lowercaseNames).size === lowercaseNames.length
    }, 'You cannot enter the same custom field twice.'),
})

export type CustomFieldsFormValues = z.infer<typeof createCFSchema>

export const createCFDefaultValues: CustomFieldsFormValues = {
  names: [],
}

export const updateCFFields = {
  name: {
    fieldProps: {
      autoFocus: true,
      label: 'Custom Field Name',
      name: 'name',
      placeholder: 'Enter custom field name',
    },
    type: 'text',
  },
} as const

export const updateCFSchema = z.object({
  name: nameSchema,
})

export type UpdateCustomFieldFormValues = z.infer<typeof updateCFSchema>

export const getUpdateCFDefaultValues = (currentName: string): UpdateCustomFieldFormValues => ({
  name: currentName,
})
